import React from 'react';
import { PhoneNumberLink } from 'shared/components/PhoneNumber';
import { PopoverButton } from 'shared/components/PopoverButton';
import { Currency } from 'shared/utils/currency';
import { PurchasePricing_RateFragment } from '../../generated.graphql';


interface Props {
  rate: PurchasePricing_RateFragment;
  startValue: string;
  className?: string;
  caret?: boolean;
}


export const PurchasePricing = (props: Props) => {
  return <>
    <p>
      Rental agreement is based on an item value of <Currency value={props.startValue}/>.<br/>
      Purchase request price guide for the selected <Currency value={props.rate.rentalMonthly} wholeDollars/>/month rate:
    </p>
    <p>
      {props.rate.purchasePricing.map(m => (
        <React.Fragment key={m.month}>
          At {m.month} month{(m.month === 1 ? '' : 's')} pay no more than <Currency value={m.amount} wholeDollars/>
          <br/>
        </React.Fragment>
      ))}
    </p>
    <p className="mb-0">
      While your contract is a rental contract, you can make us an offer to purchase at any time.{' '}
      Some price guides are set out above.{' '}
      For further price details at anytime during the rental period please contact us on <PhoneNumberLink/>{' '}
      (purchases are subject to approval and some conditions apply).
    </p>
  </>
}


export const PurchasePricingPopoverButton = (props: Props) => (
  <PopoverButton buttonText="Apply to purchase pricing" className={props.className} caret={props.caret}>
    <div className="small">
      <PurchasePricing rate={props.rate} startValue={props.startValue}/>
    </div>
  </PopoverButton>
)

